import type { ProductModelFile } from '@app/api/Products';
import type { ReminderTypes } from '@app/pages/Notifications/constants/reminderTypes';

export namespace NRecordReminders {
  export type ReminderType = (typeof ReminderTypes)[keyof typeof ReminderTypes];

  export type ModelRecordReminder = {
    Id: number;
    IsOn: boolean;
    ReminderType: ReminderType | null;
    ReminderMinutes: number;
    Text: string | null;
    Json: string | null;
    FileIds?: number[] | null;
  };

  export interface SocialIntegrationModelItem {
    Id: number;
    IdS: string | null;
    Name: string;
    BranchId?: number;
    BranchName?: string;
    SocialType: string | null;
  }

  export type ModelBranchRecordReminders = {
    AllowedIntegrations: SocialIntegrationModelItem[] | null;
    DefaultIntegrations: ModelBranchRecordReminderIntegration[];
    RecordReminders: ModelRecordReminder[] | null;
    SendByAllIntegrations: boolean;
    SendByLastActiveIntegration: boolean;
  };

  export interface ModelBranchRecordReminderIntegration {
    Id: number;
    Order: number;
  }

  export interface ModelAttachFilesToReminder {
    Id: number;
    Files: ProductModelFile[] | null;
  }

  export interface ModelRemoveFilesFromReminder {
    Id: number;
    FileIds: number[];
  }

  export interface ModelGetReminderFiles {
    Id: number;
    FileIds: number[] | null;
  }

  export interface ModelFilesByReminder {
    Id: number;
    Files: ProductModelFile[] | null;
  }
}
